import axios from 'axios'
import DocumentView from '@/core/view/DocumentView'

interface IgMediaItem {
  // 画像のURL
  media_url: string
  // サムネイル画像
  thumbnail_url: string
  // コンテンツのURL
  permalink: string
}

class MyDocument extends DocumentView {
  /**
   * コンストラクタ
   *
   */
  constructor() {
    super()
  }

  /**
   * ドキュメントが準備が出来たときに呼び出されます
   */
  public docReady(): void {
    super.docReady()
  }

  /**
   * すべての読み込みが完了した際に呼び出されます。
   */
  public docLoadAll(): void {
    super.docLoadAll()

    axios
      .get('instagram/list.php', {})
      .then((response) => {
        const igList = document.getElementById('ig-list')

        // 表示する数を確認
        const dataListCount = parseInt(
          igList?.getAttribute('data-list-count') as string,
          10,
        )

        // 表示用テンプレート
        const igListItem = document.getElementById('ig-list-item')
        const igListItemTmpl: string = igListItem?.innerHTML as string

        // 表示用テンプレート(空)
        const igListItemEmpty = document.getElementById('ig-list-item-empty')
        const igListItemEmptyTmpl: string = igListItemEmpty?.innerHTML as string

        const list: Array<IgMediaItem> = response.data.data
        list.forEach((media, index) => {
          if (dataListCount <= index) return
          let tmpl = igListItemTmpl
          tmpl = tmpl.replace('##permalink##', media.permalink)
          tmpl = tmpl.replace(
            '##media_url##',
            media.thumbnail_url ? media.thumbnail_url : media.media_url,
          )
          const element = document.createElement('div')
          element.innerHTML = tmpl

          if (element.firstElementChild)
            igList?.append(element.firstElementChild)
        })

        // 空の表示
        for (let i = list.length; i < dataListCount; i++) {
          const element = document.createElement('div')
          element.innerHTML = igListItemEmptyTmpl
          if (element.firstElementChild)
            igList?.append(element.firstElementChild)
        }
      })
      .catch(async (error) => {
        console.log(error)
      })
  }
}
new MyDocument()
